import { VStack } from '@chakra-ui/react';
import { isAuthenticated } from '@partiu/api/axios';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Logo } from '../../components/atoms/Logo';
import { MainTemplate } from '../../templates/MainTemplate';
import { RecoveryForm } from './components/RecoveryForm';
import { ChangePassForm } from './components/ChangePassForm';

export function RecoveryPage() {
  const navigate = useNavigate();
  const [isSended, setIsSended] = React.useState(false);

  if (isAuthenticated()) navigate('/');

  return (
    <MainTemplate hideTopMenu>
      <VStack
        maxH={'100vh'}
        minH={'100vh'}
        width={{ base: '85%', lg: '500px' }}
        margin={'auto'}
        paddingTop={'50px'}
      >
        <Logo height={'90px'} objectFit={'contain'} w={'auto'} />
        {isSended ? <ChangePassForm /> : <RecoveryForm setIsSended={setIsSended} />}
      </VStack>
    </MainTemplate>
  );
}
